(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsCRMController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'NotificationService'];

  function reports ($scope, $http, $timeout, ngTableParams, NotificationService) {
    var vm = this;
    vm.loading = false;
    vm.exportAs = 'csv';
    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.download = function () {
      vm.loading = true;
      $http.get(apiUrl + '/reports/crm', {
        params: {
          filters: vm.filters,
          exportAs: vm.exportAs,
          schedule: 0
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data) {
            if (data.success === false) {
              NotificationService.errorHandler(data, data.message);
              return;
            }

            if (typeof data !== 'string' &&
                        data.hasOwnProperty('sendByEmail') &&
                        data.sendByEmail === true) {
              NotificationService.warningHandler(null, $scope.labels.sendByEmail);
              return;
            }

            var filename = headers('Mktzap-Filename') || $scope.labels.filename;

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' }); // Make sure it's not visible
            angular.element(document.body).append(anchor); // Attach to document

            var blob = new Blob([
              new Uint8Array([0xEF, 0xBB, 0xBF]), // UTF-8 BOM
              data
            ], { type: 'charset=utf-8' });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove(); // Clean it up afterwards
            URL.revokeObjectURL(csvUrl); // Clean memory blob
          } else {
            NotificationService.warningHandler(null, $scope.labels.noRecordsFound);
          }
        }, function ({ data }) {
          $http.get(apiUrl + '/reports/crm', {
            params: {
              filters: vm.filters,
              exportAs: vm.exportAs,
              schedule: 1
            }
          })
            .then(function ({ data }) {
              NotificationService.warningHandler(null, $scope.labels.sendByEmail);
            }, function ({ data }) {
              if (data && data.message) {
                NotificationService.errorHandler(data, data.message);
              } else {
                NotificationService.errorHandler();
              }
            })
        })
      vm.loading = false;
    };
  }
})();
